import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const AnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem("announcement_dismissed") === "true";
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("announcement_dismissed", "true");
  };

  return (
    <div
      className="bg-primary text-primary-foreground py-2 px-4 text-center text-sm relative"
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <span>
          Original pyrography &amp; limited editions — by private enquiry &middot;{" "}
          <Link to="/the-collection" className="underline font-medium hover:no-underline">
            View the Collection
          </Link>
        </span>
        <button
          onClick={handleDismiss}
          className="absolute right-3 p-1 hover:bg-primary-foreground/10 rounded transition-colors"
          aria-label="Dismiss announcement"
          data-testid="dismiss-announcement"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
